// ADDED
import React from "react";
import { GeneralMessage, useGeneralMessage } from "../../../common/APICommon";
import LoanTransactionModule from "../../components/modules/LoanTransactions/LoanTransactionModule";

const LoanTransactionPage = ({ user, userAccess, isHideSideMenu }) => {
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="EmployeesTabInfo shadow-xl bg-white rounded-lg overflow-hidden">
          <div className="employeesTab-header p-4 border-b">
            <div className='sub-title row text-sm'>
              <span className="text-gray-400">{"Personnel > "}</span>
              <span className="border-b border-black">{"Loan Transactions"}</span>
            </div>
            <h3 className="text-xl font-bold mt-2">Loan Transactions</h3>
          </div>

          <div className='p-4'>
            <LoanTransactionModule
              user={user}
              showGeneralMessage={showGeneralMessage}
            />
          </div>
        </div>
      </div>
      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </div>
  );
};

export default LoanTransactionPage;